export const LOGO = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const USER_AVATAR = "https://occ-0-1492-3663.1.nflxso.net/dnm/api/v6/K6hjPJd6cR6FpVELC5Pd6ovHRSk/AAAABdpkabKqQAxyWzo6QW_ZnPz1IZLqlmNfK-t4L1VIeV1DY00JhLo_LMVFp936keDxj-V5UELAVJrU--iUUY2MaDxQSSO-0qw.png?r=e6e";

export const LOGIN_PAGE_BACKGROUND = "https://assets.nflxext.com/ffe/siteui/vlv3/893a42ad-6a39-43c2-bbc1-a951ec64ed6d/1d86e0ac-428c-4dfa-9810-5251dbf446f8/IN-en-20231002-popsignuptwoweeks-perspective_alpha_website_large.jpg";

export const TMDB_API_KEY = process.env.REACT_APP_TMDB_KEY;

export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
    },
  };

export const IMG_CDN = "https://image.tmdb.org/t/p/w400";

export const SUPPORTED_LANGUAGES = [{identifier: "en", name: "English"},
                                    {identifier: "hindi", name: "Hindi"},
                                    {identifier: "spanish", name: "Spanish"} ];

